/** Вход в кабинет: почта и пароль. Публичной регистрации нет — аккаунт выдаёт владелец. */
import { ApiError } from '@allswipes/client';
import { Button, Card, Field, Logo } from '@allswipes/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { api } from '../api';
import { useConsole } from '../session';

export function LoginScreen() {
  const navigate = useNavigate();
  const { refresh } = useConsole();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.consoleLogin(email, password);
      await refresh();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось войти');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <Card className="box raised">
        <div style={{ marginBottom: 14 }}>
          <Logo height={20} />
          <div className="faint" style={{ fontSize: 11.5, marginTop: 6 }}>
            кабинет партнёра
          </div>
        </div>
        <p className="sub" style={{ marginBottom: 16 }}>
          Создавай акции, проводи розыгрыши, выдавай призы.
        </p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}
        >
          <Field label="Почта">
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>
          <Field label="Пароль">
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          {/*
            Ошибка показывается над кнопкой, а не под полем пароля. Под полем
            любая причина читается как «пароль неверный» — и недоступный
            сервер отправляет человека перебирать пароли вместо того, чтобы
            проверить, поднят ли он вообще.
          */}
          {error && (
            <p className="sub" style={{ color: 'var(--bad)', marginBottom: 12 }} role="alert">
              {error}
            </p>
          )}
          <Button variant="pri" block type="submit" disabled={busy}>
            {busy ? 'Проверяем…' : 'Войти'}
          </Button>
        </form>

        <p className="sub" style={{ marginTop: 16, fontSize: 12 }}>
          Нет доступа? Аккаунт создаёт владелец бренда — публичной регистрации нет, пока нет
          проверки брендов.
        </p>
      </Card>
    </div>
  );
}
